export default __webpack_public_path__ + "static/benefit1-9b7588493b14d02e5080fd662f7472fc.svg";